var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForkSpaghetti(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 417,
    viewBox: "0 0 180 417",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M164 0H16C7.16344 0 0 7.16344 0 16V400.01C0 408.847 7.16344 416.01 16 416.01H164C172.837 416.01 180 408.847 180 400.01V16C180 7.16344 172.837 0 164 0Z",
    fill: "#FF9685"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.94 155.82C63.69 155.38 57.67 154.47 58.16 138.35C58.4 130.82 58.94 44.25 59.26 22.53C59.26 19.8 60.94 17.53 62.94 17.53H63.94C65.94 17.46 67.61 19.62 67.62 22.38L68.09 104.57C68.09 107.34 69.76 109.51 71.8 109.41H72.74C74.74 109.32 76.39 107.02 76.39 104.27L76.48 23.11C76.48 20.36 78.12 18.06 80.14 17.97C82.14 17.88 83.81 19.97 83.85 22.76L85 108.77C85 111.55 86.74 113.69 88.78 113.55L90.02 113.46C92.02 113.32 93.66 110.98 93.62 108.21L92.41 21.78C92.41 18.95 94.05 16.58 96.13 16.52H97.02C99.02 16.47 100.59 18.52 100.67 21.2L102.8 104.49C102.88 107.2 104.52 109.27 106.51 109.18H107.11C109.11 109.08 110.8 106.73 110.77 103.95L110 20.47C110 17.75 111.54 15.47 113.53 15.25H113.85C115.85 15.07 117.53 17.06 117.67 19.77C118.28 31.94 119.86 64.98 120.67 95.4C121.1 111.23 121.52 126.71 121.67 138.28C121.77 148.28 120.23 156.21 111.37 156C97.27 155.62 70.05 155.83 69.94 155.82Z",
    fill: "#CCC2C2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M91.66 404.64C88.8627 404.64 86.1026 403.999 83.5916 402.766C81.0806 401.534 78.8854 399.742 77.1745 397.529C75.4635 395.316 74.2824 392.741 73.7217 390C73.161 387.26 73.2357 384.427 73.94 381.72L77.29 368.85C78.24 365.18 79.01 348.08 79.01 344.29L82.53 181.11C82.53 169.77 74.32 159.57 64.08 154.71L116.9 154.55C108.96 159.6 100.09 171.19 100.09 180.61L103.89 341.61C104.185 351.635 105.08 361.632 106.57 371.55L109.3 381.39C110.063 384.112 110.185 386.974 109.657 389.751C109.128 392.528 107.964 395.145 106.256 397.397C104.547 399.649 102.34 401.475 99.8079 402.732C97.2757 403.988 94.4868 404.641 91.66 404.64Z",
    fill: "#CCC2C2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M138 80.59C138 80.59 131.17 69.46 119.73 71.36C108.29 73.26 48.48 74.22 54.39 68.78C59.71 63.89 110.02 63.18 119.97 62.78C121.516 62.734 123.035 62.3662 124.43 61.7C128.55 59.7 129.75 49.5 63.64 50.7C60.8046 50.7553 57.9807 50.3257 55.29 49.43C49.21 47.43 42.02 43.43 65.02 40.61C97.37 36.61 131.15 47.23 127.84 38.25C124.53 29.27 56.58 38.25 36.84 26.36",
    stroke: "#FFE888",
    strokeWidth: 5.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.82 61.23V69.63L62.43 69.21C62.21 69.21 61.28 69.05 61.07 69L58.92 68.66V61.97L67.82 61.23Z",
    fill: "#CCC2C2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.42 61.23V68.46L84.47 68.05L84.36 60.5L76.42 61.23Z",
    fill: "#CCC2C2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M92.99 60.03L93.09 67.52L101.88 66.76L101.7 60.03H92.99Z",
    fill: "#CCC2C2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M110.36 59.73L110.43 66.64L119.68 66L119.42 59.39L110.36 59.73Z",
    fill: "#CCC2C2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M59.08 38.18L59.02 44.94L67.73 44.44L67.69 37.19L59.08 38.18Z",
    fill: "#CCC2C2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4499 36.78L76.4399 43H84.1199L84.0299 36.78H76.4499Z",
    fill: "#CCC2C2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M92.66 36.78L92.76 43.68H101.29L101.12 37.19L92.66 36.78Z",
    fill: "#CCC2C2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M110.21 44.76L110.14 38.27L118.53 38.58L118.84 45.52L110.21 44.76Z",
    fill: "#CCC2C2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M94.25 401.66C96.9222 401.328 99.4451 400.243 101.525 398.533C103.605 396.823 105.157 394.557 106 392",
    stroke: "#EDE8E8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M106.74 384C107.06 385.554 107.06 387.156 106.74 388.71",
    stroke: "#EDE8E8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M96.47 184.36L99.67 295.26",
    stroke: "#EDE8E8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M110.83 109.18C110.83 109.18 108 113.35 104.83 110.41",
    stroke: "#EDE8E8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3801 114.4C92.3801 114.4 90.0101 117.25 86.0601 114.77",
    stroke: "#EDE8E8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M68.47 109.57C68.9398 110.203 69.5863 110.683 70.3283 110.95C71.0702 111.217 71.8744 111.259 72.64 111.07",
    stroke: "#EDE8E8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M113.42 16.56C113.643 16.4429 113.889 16.376 114.141 16.3639C114.393 16.3519 114.644 16.395 114.878 16.4902C115.111 16.5855 115.321 16.7306 115.492 16.9154C115.664 17.1002 115.793 17.3202 115.87 17.56",
    stroke: "#EDE8E8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2 18C96.4239 17.8829 96.6707 17.8159 96.9231 17.8038C97.1755 17.7917 97.4276 17.8347 97.6617 17.9299C97.8958 18.0251 98.1064 18.1701 98.2788 18.3549C98.4512 18.5397 98.5813 18.7599 98.66 19",
    stroke: "#EDE8E8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M79.37 19.44C79.5939 19.3229 79.8407 19.2559 80.0931 19.2438C80.3456 19.2317 80.5976 19.2747 80.8317 19.3699C81.0659 19.4651 81.2764 19.6101 81.4488 19.7949C81.6212 19.9797 81.7513 20.1999 81.83 20.44",
    stroke: "#EDE8E8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M63.38 18.86C63.6032 18.7429 63.8493 18.676 64.1011 18.6639C64.3528 18.6519 64.6042 18.695 64.8376 18.7902C65.0709 18.8855 65.2807 19.0305 65.4521 19.2153C65.6235 19.4001 65.7525 19.6201 65.83 19.86",
    stroke: "#EDE8E8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M123.23 70C123.23 70 129.01 70 135.36 76.68",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M55.64 67.23C55.64 67.23 53.44 67.77 55.22 69.46C57 71.15 63.32 71.04 63.32 71.04",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M126.85 57.65C126.85 57.65 124.85 54.22 118.85 52.57",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7601 48.9C59.7601 48.9 53.7101 48.37 52.1801 46.53C50.6501 44.69 50.9601 43.15 52.7901 43",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M128.82 38.27C128.82 38.27 127.67 34.51 120.4 33.97",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M116.95 33.59H113.42",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M38.86 26.41C40.8968 27.8847 43.3454 28.6822 45.86 28.69",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M83.78 48.9C87.4773 48.9317 91.1698 49.1721 94.84 49.62",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForkSpaghetti);
export default __webpack_public_path__ + "static/media/fork_spaghetti.ad8dde479d8ebbe91a14e40e037c838c.svg";
export { ForwardRef as ReactComponent };